var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNavigation2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    xmlSpace: "preserve",
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 43,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAK5SURBVFhH7ZaxThVBFIa5rQkJiRWEworaxIoOe3wAOmwwdiTURioribbYSKW9PgA+gEZrGy1MrIwmFpbX79uc2cydOwMX5cIt9kv+7M6ZM3N+zs7uZWkejMfjWyqGi0sY/RJaXMOZ0cRiGtZUmCtZLMOaCVMtFsOwJsLMeVyvYYuHiVm5HsMWjeIX5WoNWyyK1jC+hXbjvsbVGLZIFKvxHK1Easo9caLCfA27eRQpMbYVOcvoGG13i4D7VpfnY9hNY/OSvptcNfoKvQ/tdYuBe9c/QyWXa9jNYtMcx103hfvS6JRhYex5ru31/4bdJDbLOUT52VxFb1BpNGnCsBB7jHLONTyKa5VYfIrSJp/Q/dFo5LWDnFUux2itC7R5zbqjuO+o7P8V3SXP6+y4EUod/Yn2Y6qHWK2jvlwbaAedRizpMJZOQDzv8sWOhMmxSCw4tZhYadS8nZjuYLyGPDK5Yc/1cqT0EMtrzmbYpEiudlOIl0afov4YcH9TxdCxL9VblBv2+ExBfB9Z+2zDTkZStZtC3EecHq8G7sRUB2ONPgn1hoXxHkqG/WNbhvXhj0ndcCR8RNVuCnO50QM08TgZJ6OeW1UznB+NpmFhzh+TvnGjCDrQ5CFv4i9jJeTYwafoM3pB3gfjCeY1dYAmzMEPdES+1x7y73HxkzZGD5j/brwkvO2iEwcr6HY304D5bTT1AiWI5x19hNaRa5odFmL+kHg03HsjwlWY73+AmpCUila/o8Rzo/3/AxJzD2OualiIezR8SSfWl3THoAWLu7+GR/SuCxREcR/9H/SSvG/GS8jb5OJjl6kjkSDPnN+tek1Y6COa+h4mNIrs1pndSES+L0yzw8KcXW7WvTAWQz7e9QjNDGs2kV+SpuFLwyIWjOE/wfob7jF3wxaK24GBgYGBgYGBgYHrZWnpL68+Tptzl6SuAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNavigation2X);
export default __webpack_public_path__ + "static/media/IMG_navigation@2x.9d90190027365207cc57ffd7cb6b83e7.svg";
export { ForwardRef as ReactComponent };